// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { CancellationRequestDetail } from './cancellation-request-detail';
import { CancellationRequestStatus } from './cancellation-request-status';
import { JoHeader } from './jo-header';
import { CancellationRequestStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CancellationRequest extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Enum FK cancellationRequestStatus */
  cancellationRequestStatusId!: CancellationRequestStatusEnum;
  /** Int32 FK joHeader */
  joHeaderId!: number;
  /** Guid */
  proximityCancellationRequestId?: string;
  /** DateTimeOffset */
  receivedTs!: Date;
  /** Inv FK cancellationRequestId */
  cancellationRequestDetails!: CancellationRequestDetail[];
  /** FK cancellationRequestStatusId */
  cancellationRequestStatus!: CancellationRequestStatus;
  /** FK joHeaderId */
  joHeader!: JoHeader;
}

